import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs'
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class ApiService {
    private api_url: string = '';
    
    constructor(private http: HttpClient){}

    formDataFor(payload: {}) {
        const fd = new FormData();
        _.forEach(_.toPairs(payload), pair =>
            Array.isArray(pair[1]) ?
              _.forEach(pair[1], val => val && fd.append(pair[0], val)) :
              pair[1] && fd.append(pair[0], pair[1] as any));
        return fd;
      }

    paramify = (params): HttpParams => params ? _.entries(params).reduce((col, entry) => typeof entry[1] !== 'undefined' ? col.set(entry[0], (entry[1] as any)) : col, new HttpParams()) : undefined;

    get = (path: string, params?: HttpParams): Observable<any> => this.http.get(`${this.api_url}${path}`, { params});

    put = (path: string, body, options?: any): Observable<any> => this.http.put(`${this.api_url}${path}`, body, options);

    patch = (path: string, body): Observable<any> => this.http.patch(`${this.api_url}${path}`, body);

    post = (path: string, body, options?: any): Observable<any> => this.http.post(`${this.api_url}${path}`, body, options);

    delete = (path: string, options?: any): Observable<any> => this.http.delete(`${this.api_url}${path}`, options);
}
